module.exports = __webpack_public_path__ + "static/media/ic-copy-to-clipboard.2182fd91.svg";